import { render, staticRenderFns } from "./GstockyAI.vue?vue&type=template&id=539e5860&scoped=true"
import script from "./GstockyAI.vue?vue&type=script&lang=js"
export * from "./GstockyAI.vue?vue&type=script&lang=js"
import style0 from "./GstockyAI.vue?vue&type=style&index=0&id=539e5860&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e5860",
  null
  
)

export default component.exports